import { render } from "./TeaInfo.vue?vue&type=template&id=951f3202&scoped=true"
import script from "./TeaInfo.vue?vue&type=script&lang=ts"
export * from "./TeaInfo.vue?vue&type=script&lang=ts"

import "./TeaInfo.vue?vue&type=style&index=0&id=951f3202&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-951f3202"

export default script